import React, { useContext, useEffect, useState } from 'react';
import { skip, tap } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';

import { AggregationSelections } from 'src/components/CategoryListingPage/utils/cleanAggregations';
import { CategoryQueryContext } from 'src/components/CategoryListingPage/CategoryQueryProvider';
import { AggregationQueryContext } from 'src/components/CategoryListingPage/AggregationQueryProvider';
import { ProductListQueryContext } from 'src/components/CategoryListingPage/ProductListQueryProvider';
import { Spinner } from 'src/components/Layout/Spinner';

import { EMPTY_ARR } from './LayeredNav';
import { AggregationItem } from './AggregationItem';
import { LayeredNavQueryContext, LayeredNavQueryProvider } from './LayeredNavQueryProvider';
import classes from './AggregationList.scss';

export type AggregationListProps = {
    current?: React.ReactNode;
    isMob: boolean;
    onChange: (checked: boolean, code: string, label: string) => void;
    selection$: BehaviorSubject<AggregationSelections>;
};

export function AggregationList(props: AggregationListProps) {
    const { category_id } = useContext(CategoryQueryContext);

    return (
        <LayeredNavQueryProvider id={category_id}>
            <AggregationListInner
                current={props.current}
                selection$={props.selection$}
                onChange={props.onChange}
                isMob={props.isMob}
            />
        </LayeredNavQueryProvider>
    );
}

export type AggregationListInnerProps = {
    current?: React.ReactNode;
    isMob: boolean;
    onChange: (checked: boolean, code: string, label: string) => void;
    selection$: BehaviorSubject<AggregationSelections>;
};

function AggregationListInner(props: AggregationListInnerProps) {
    const { selection$, current } = props;
    const { aggregations } = useContext(LayeredNavQueryContext);
    const { loading } = useContext(ProductListQueryContext);
    const { mappedAggregations } = useContext(AggregationQueryContext);
    const [selected, setValues] = useState(selection$.value);

    useEffect(() => {
        const sub = selection$
            .pipe(
                skip(1),
                tap((selections) => setValues(selections)),
            )
            .subscribe();
        return () => sub.unsubscribe();
    }, [mappedAggregations, selection$]);

    return (
        <div className={classes.filtersSelections} data-loading={String(loading)}>
            {loading && (
                <div className={classes.filtersloader}>
                    <Spinner />
                </div>
            )}

            {Boolean(aggregations.length) && <h2 className={classes.title}>Filters</h2>}

            {current}

            {aggregations.map((aggregation) => {
                const selections: string[] = selected[aggregation.attribute_code] || EMPTY_ARR;

                return (
                    <AggregationItem
                        key={aggregation.attribute_code}
                        item={aggregation}
                        selections={selections}
                        onChange={props.onChange}
                    />
                );
            })}
        </div>
    );
}

export default AggregationList;
